'use strict';

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*

'STATUS_CODE_ACTIVE': 'A',
'STATUS_CODE_PORTING_DENIED': 'D',
'STATUS_CODE_PORTING_LOA_COMPLETED': '4',
'STATUS_CODE_PORTING_ACCEPTED': '2',
'STATUS_CODE_PORTING_STARTED': '1'
*/

module.exports = _model2['default'].extend({

    /**
     */

    apiEndpointAlias: 'faxLines',

    /**
    */

    mixins: [require('common/models/mixins/model')],

    /**
    */

    fromData: function fromData(data) {
        return {
            guid: data.guid,
            number: '+' + String(data.number).replace(/^\+/, ''),
            statusCode: data.statusCode || data.status,
            teamMembers: data.teamMembers || []
        };
    },


    /**
    */

    toData: function toData() {
        return {
            guid: this.guid,
            number: this.number,
            statusCode: this.statusCode,
            teamMembers: this.teamMembers || []
        };
    },


    /**
    * TODO - this works for now. Ideally we'd have faxline.getMembers() in the future. (CC)
    */

    setMembers: function setMembers(members) {
        this.teamMembers = members;
        return this.save();
    },


    /**
    */

    isDenied: function isDenied() {
        return this.statusCode === 'D';
    },


    /**
    */

    isActive: function isActive() {
        return (/A/.test(String(this.statusCode))
        );
    },


    /**
    */

    isAccepted: function isAccepted() {
        return (/4|2/.test(String(this.statusCode))
        );
    },


    /**
    */

    isPorting: function isPorting() {
        return (/1/.test(String(this.statusCode))
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/fax-line.js
 ** module id = 514
 ** module chunks = 0 1
 **/